// extracted by mini-css-extract-plugin
export default {"FAQTakeover__accordionGroup":"F0Eoftl0SN"};